import httpService from '@/services/httpService'

const types = {
  ADD_KEYWORD_ATTRIBUTES: 'keyword-attributes/ADD_KEYWORD_ATTRIBUTES'
}

const state = {
  keywordAttributes: []
}

const mutations = {
  [types.ADD_KEYWORD_ATTRIBUTES]: function (state, keywordAttributes) {
    state.keywordAttributes = keywordAttributes
  }
}

const actions = {
  getKeywordAttributeData: async function ({ commit, dispatch }, { clientId, filters }) {
    const params = { filters: JSON.stringify(filters) }
    const response = await httpService.get(`/keyword-attribute/${clientId}`, { params })
    if (!response) {
      commit(types.ADD_KEYWORD_ATTRIBUTES, [])
      return []
    }
    commit(types.ADD_KEYWORD_ATTRIBUTES, response.data)
    return response.data
  },
  getKeywordCount: async function (store, attributeId) {
    const response = await httpService.get(`/keyword-attribute/count/${attributeId}`)
    if (!response || !response.data) {
      return 'error'
    }
    return response.data.keywords_count
  },
  createKeywordAttribute: async function ({ commit }, { clientId, keywordAttribute }) {
    keywordAttribute = {
      is_active: keywordAttribute.is_active,
      name: keywordAttribute.name,
      inclusion_list: keywordAttribute.inclusion_list,
      exclusion_list: keywordAttribute.exclusion_list
    }
    const response = await httpService.post(`/keyword-attribute/${clientId}`, keywordAttribute,
      { successMessage: 'Keyword Attribute successfully created', raiseError: true, cancelErrorMessage: true })
    return response.data
  },
  deleteKeywordAttributeById: function ({ commit }, { clientId, keywordAttributeId }) {
    const config = {
      params: {
        id: keywordAttributeId
      },
      successMessage: 'Keyword Attribute successfully deleted',
      raiseError: true,
      cancelErrorMessage: true
    }
    return httpService.delete(`/keyword-attribute/${clientId}`, config)
  },
  updateKeywordAttribute: function ({ commit }, { clientId, keywordAttribute }) {
    keywordAttribute = {
      id: keywordAttribute.id,
      is_active: keywordAttribute.is_active,
      name: keywordAttribute.name,
      inclusion_list: keywordAttribute.inclusion_list,
      exclusion_list: keywordAttribute.exclusion_list
    }
    return httpService.patch(`/keyword-attribute/${clientId}`, keywordAttribute,
      { successMessage: 'Keyword Attribute successfully updated', raiseError: true, cancelErrorMessage: true })
  }
}

export default {
  namespaced: true,
  mutations,
  state,
  actions
}
